import {DialogOverlayContentDefaultBox} from './dialog-overlay-content.default.box';

export const DialogOverlayContentBox = DialogOverlayContentDefaultBox;